// extracted by mini-css-extract-plugin
export var divider = "projects-module--divider--7acn+";
export var row = "projects-module--row--JhBh-";
export var title = "projects-module--title--N1d0t";
export var desc = "projects-module--desc--xGdPo";
export var moreProjectsDiv = "projects-module--moreProjectsDiv--x2Fdx";
export var hoverOverMe = "projects-module--hoverOverMe--eKRDC";
export var hoverMoreProject = "projects-module--hoverMoreProject--DXssF";
export var moreProjects = "projects-module--moreProjects--Pbh7s";